export default __webpack_public_path__ + "static/media/deal-8.9c4230b6.webp";